import { Component, OnInit, Renderer2, Inject, ViewChild } from '@angular/core';
import { OwnerInfoService } from 'src/app/service/owner-info/owner-info.service';
import { Router } from '@angular/router';
import { LocalstorageService } from 'src/app/service/shared/localstorage/localstorage.service';
import { DOCUMENT } from '@angular/common';
import { StatesService } from 'src/app/service/states/states.service';
import { LoaderService } from 'src/app/service/shared/loader/loader.service';
import { ExportToCsv } from 'export-to-csv';
import getAndParseUserPermissions from 'src/app/helpers/parsePermissions';

@Component({
  selector: 'app-owner-info',
  templateUrl: './owner-info.component.html',
  styleUrls: ['./owner-info.component.scss'],
})
export class OwnerInfoComponent implements OnInit {
  @ViewChild('closebutton') closebutton;

  ownerInfoData = [];
  statesData = [];
  cityData = [];
  noDataMsg = '';
  searchInfo = {};
  userPermissions;
  permissionMap: any = {
    owner_info_v: false,
    owner_info_e: false,
  };

  constructor(
    private ownerInfoService: OwnerInfoService,
    // Still needed in order for getAndParseUserPermissions to work correctly.
    private localStorageService: LocalstorageService,
    private router: Router,
    private renderer2: Renderer2,
    @Inject(DOCUMENT) private _document,
    private statesServices: StatesService,
    private loaderService: LoaderService,
  ) {
    this.userPermissions = getAndParseUserPermissions(this.localStorageService)
    this.loaderService.displayLoader();
    this.disableFormGroupByRole();
  }

  ngOnInit(): void {
    this.getOwnerInfo();
    this.getAllOwner();
    this.getStates();
    setTimeout(() => {
      this.loadSelect2();
    }, 1000);
  }

  ngAfterViewInit(): void { }

  disableFormGroupByRole() {
    setTimeout(() => {
      this.checkForPermission(this.userPermissions['owner_info'], 'owner_info');
    }, 1000);
  }

  checkForPermission(permission, val) {
    switch (val) {
      case 'owner_info':
        this.disableOwnerInfoForm(permission);
        break;
      default:
        break;
    }
  }

  disableOwnerInfoForm(permission) {
    if (permission['view'] === 1 && permission['edit'] === 0) {
      this.permissionMap.owner_info_v = true;
    } else if (permission['view'] === 1 && permission['edit'] === 1) {
      this.permissionMap.owner_info_v = true;
      this.permissionMap.owner_info_e = true;
    }
  }

  //To clear datatable
  clearDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `clearDatatable('.owner-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  //To draw datatable with data
  drawDatatable() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `reloadDataTable('.owner-data-table')`;
    this.renderer2.appendChild(this._document.body, s);
  }

  loadSelect2() {
    const s = this.renderer2.createElement('script');
    s.type = 'text/javascript';
    s.text = `loadSelect2();`;
    this.renderer2.appendChild(this._document.body, s);
  }

  getAllOwner() {
    this.ownerInfoService.getOwnerInfo().subscribe(
      res => {
        this.cityData = res.data.filter(
          (test, index, array) => index === array.findIndex(findTest => findTest.city === test.city),
        );
      },
      error => this.onError(error),
    );
  }

  //To get all owner data
  getOwnerInfo() {
    this.ownerInfoService.getOwnerInfo(this.searchInfo).subscribe(
      res => this.onSuccess(res),
      error => this.onError(error),
    );
  }

  //On success of api call
  onSuccess(result) {
    if (result) {
      if (result.data) {
        this.clearDatatable();
        this.ownerInfoData = result.data;
        this.loadSelect2();
        this.drawDatatable();
        this.loaderService.hideLoader();
      } else {
        this.noDataMsg = result.errors;
        this.loaderService.hideLoader();
      }
    }
  }

  //On error of api call
  onError(error) {
    this.loaderService.hideLoader();
  }

  //To get all states data
  getStates() {
    this.statesServices.getStates().subscribe(
      res => this.onStatesSuccess(res),
      error => this.onStatesError(error),
    );
  }

  //On success of states api call
  onStatesSuccess(result) {
    if (result) {
      if (result.data) {
        this.statesData = result.data;
      } else {
        this.noDataMsg = result.errors;
      }
    }
  }

  //On error of states api call
  onStatesError(error) { }

  //Open owner info page
  openAddEditOwnerInfo(ownerInfoId = '') {
    if (this.permissionMap.owner_info_v && this.permissionMap.owner_info_e) {
      if (ownerInfoId != '') {
        this.router.navigate(['owner_info/add_edit', { id: ownerInfoId }]);
      } else {
        this.router.navigate(['owner_info/add_edit']);
      }
    }
  }

  searchInOwner(value, key) {
    if (value == '') {
      delete this.searchInfo[key];
    }
    this.searchInfo[key] = value;
    this.getOwnerInfo();
  }

  generateCSV() {
    const options = {
      filename: 'Owners and Facility',
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      // showTitle: true,
      // title: 'Users Data Export CSV',
      useTextFile: false,
      useBom: true,
      useKeysAsHeaders: true,
      // headers: ['Job', 'Owner', 'Facility/Location', 'Street Address', 'City', 'State', 'Zipcode'] // Won't work with useKeysAsHeaders present!
    };

    const csvExporter = new ExportToCsv(options);

    let ownerFacilityExport = [];
    // this.ownerInfoService.getExportOwnerFacilityInfo().subscribe(
    //   (res) => {
    //     if (res) {
    //       if (res.data) {
    //         res.data.forEach(element => {
    //           let newData = {
    //             "Job": element.number,
    //             "Owner": element.owner_name,
    //             "Facility/Location": element.facility_name,
    //             "Street Address": element.street_address,
    //             "City": element.city,
    //             "State": element.abbreviation,
    //             "Zipcode": element.zipcode
    //           }
    //           ownerFacilityExport.push(newData);
    //         });
    //         csvExporter.generateCsv(ownerFacilityExport);
    //       }
    //     }
    //   }
    // )
    this.ownerInfoData.forEach(element => {
      let newData = {
        // "Job": element.number,
        Owner: element.owner_name,
        'Facility/Location': element.facility_name,
        'Street Address': element.street_address,
        City: element.city,
        State: element.abbreviation != null ? element.abbreviation : '',
        Zipcode: element.zipcode,
        Code: element.code != null && element.code != undefined && element.code != '' ? element.code : '',
      };
      ownerFacilityExport.push(newData);
    });

    csvExporter.generateCsv(ownerFacilityExport);

    this.closebutton.nativeElement.click();
  }
}
